enum LinkType {
  CUSTOM = 'custom',
  PREDEFINED = 'predefined',
}

export { LinkType };
